import axios from 'axios'

const reportes = {
    state: () => ({}),

    getters: {  },

    mutations: {  },

    actions: {
        reporteSenasoft(context, reporte) {
            return new Promise((resolve, reject) => {
                axios.get("/api/senasoft/reportes", {
                    params: reporte,
                    responseType: 'blob'
                })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
            })
        },

        reporteWorldSkills(context, reporte) {
            return new Promise((resolve, reject) => {
                axios.get("/api/worldskills/reportes", {
                     params: reporte,
                     responseType: 'blob' 
                    })
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        },
        descargarCampesenaReporte(context, reporte) {
            return new Promise((resolve, reject) => {
                axios.get("/api/campesena/reportes", {
                    params: reporte,
                    responseType: 'blob'
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}

export default reportes